export default {
    "name": "GetDefaultCarOptions",
    "kind": "HoudiniQuery",
    "hash": "e0989e927b1e84b891d13b6845ff3d98c1c872ceb1073793aaa931cb4b63456c",

    "raw": `query GetDefaultCarOptions {
  getDefaultCarOptions {
    car {
      fullname
      options {
        carId
        motor
        energy
        constructionYears
      }
    }
    userCarId
  }
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "getDefaultCarOptions": {
                "type": "DefaultCarOptions",
                "keyRaw": "getDefaultCarOptions",

                "selection": {
                    "fields": {
                        "car": {
                            "type": "CarModelSearchMatch",
                            "keyRaw": "car",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "fullname": {
                                        "type": "String",
                                        "keyRaw": "fullname",
                                        "visible": true
                                    },

                                    "options": {
                                        "type": "CarOption",
                                        "keyRaw": "options",

                                        "selection": {
                                            "fields": {
                                                "carId": {
                                                    "type": "String",
                                                    "keyRaw": "carId",
                                                    "visible": true
                                                },

                                                "motor": {
                                                    "type": "String",
                                                    "keyRaw": "motor",
                                                    "visible": true
                                                },

                                                "energy": {
                                                    "type": "CarEnergy",
                                                    "keyRaw": "energy",
                                                    "visible": true
                                                },

                                                "constructionYears": {
                                                    "type": "String",
                                                    "keyRaw": "constructionYears",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "userCarId": {
                            "type": "String",
                            "keyRaw": "userCarId",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=1d072eb8f893a8eaf181494ff1fd9958f0c42dba4496fbcc472f1a3abc29f6b0";